import React from "react";
import Welcome from "./Welcome";
import A from "../stats/A";
import B from "../stats/B";

export default function Home() {
  return (
    <div className="row">
      <div className="col-md-8 col-12 mb-3">
        <Welcome />
      </div>
      <div className="col-md-4 col-12 mb-3">
        <div className="row">
          <A />
          <B />
        </div>
      </div>
    </div>
  );
}
